import { Component } from '@angular/core';
import { ErrorNotificationService } from 'src/services';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {

  title = 'PipelineDashboard';
  public readonly apiError = this.errorNotifications.currentError;

  constructor(private errorNotifications: ErrorNotificationService) {}

  public dismissApiError(): void {
    this.errorNotifications.dismiss();
  }
}